export const OS = {
    WIN: 'windows',
    MAC: 'mac',
    LINUX: 'linux',
    UNIX: 'unix',
    OTHER: 'other'
}

/* Returns the user's os.
 */
export function getOS(){
    if (navigator.appVersion.indexOf("Win") != -1) return OS.WIN
    if (navigator.appVersion.indexOf("Mac") != -1) return OS.MAC
    if (navigator.appVersion.indexOf("X11") != -1) return OS.UNIX
    if (navigator.appVersion.indexOf("Linux") != -1) return OS.LINUX
    return OS.OTHER
}



// WEBPACK FOOTER //
// ./src/scripts/utils/DetectOS.js